import { Paper, Typography } from '@mui/material'
import { useState } from 'react'
import { EmailChipField } from './EmailChipField'
import { P2PPrimaryButton } from '../P2PButtons'
import { styles } from './InviteeList.styles'

interface Props {
  isSending: boolean
  onSend: (emails: string[]) => Promise<boolean>
}

export const InviteForm = ({ isSending, onSend }: Props): JSX.Element => {
  const [emails, setEmails] = useState<string[]>([])
  const [hasInvalid, setHasInvalid] = useState<boolean>(false)

  const send = async (): Promise<void> => {
    if (await onSend(emails)) setEmails([])
  }

  return (
    <Paper variant='outlined' sx={styles.panel}>
      <Typography variant='h4'>Invite Users</Typography>
      <Typography variant='body1' sx={styles.formDescription}>Type or paste email addresses. Separate multiple emails with a comma.</Typography>
      <EmailChipField emails={emails} onChange={setEmails} onInvalidChange={setHasInvalid} />
      <P2PPrimaryButton
        onClick={() => { void send() }}
        dataTestId='p2pSendInvitations'
        disabled={isSending || emails.length === 0 || hasInvalid}
        sx={styles.sendButton}
      >
        Send Invites
      </P2PPrimaryButton>
    </Paper>
  )
}
